// extracted by mini-css-extract-plugin
module.exports = {"root":"StickyBox_root__3Sj78","left":"StickyBox_left__2n4fj","right":"StickyBox_right__1uscO"};